import React from 'react';
import InputFeedback from '../InputFeedback';
import './GroupInput.css';

const GroupInput = ({
  innerComponent: Component,
  form,
  field,
  isErrorMessage = true,
  ...rest
}) => {
  const { errors, touched } = form;
  const error = touched[field.name] && errors[field.name];
  return (
    <React.Fragment>
      {/*<div className="group-input">*/}
      <Component
        className={error ? 'invalid' : ''}
        {...field}
        {...rest}
        meta={form}
      />
      {isErrorMessage ? <InputFeedback error={error} /> : null}
      {/*</div>*/}
    </React.Fragment>
  );
};

export default GroupInput;
